import { z } from 'zod';
import type {
  budgetAndExecutionPathObj,
  policyProjectPathObj,
  projectPathObj,
} from '../models/pinpoint-path';

/// ////////////////////////////////////////////
/// tabごとのフィールド定義
/// ////////////////////////////////////////////

//// 基本情報タブ

export const RsSkippedReviewBasicInformationScenePinpointFieldEnum = z.enum([
  'rs.skippedReview.recurring-stats-table',
  'rs.skippedReview.snapshot',
  'rs.skippedReview.organization-in-charge',
  'rs.skippedReview.people-in-charge',
  'rs.skippedReview.business-manager',
  'rs.skippedReview.other-organization-in-charge',
  'rs.skippedReview.related-organizations',
  'rs.skippedReview.project-number',
  'rs.skippedReview.project-group',
  'rs.skippedReview.reason',
  'rs.skippedReview.reason-supplement',
  'rs.skippedReview.expenditure-purpose-level-3-1',
  'rs.skippedReview.sheet-type',
  'rs.skippedReview.fiscal-year',
  'rs.skippedReview.project-category',
  'rs.skippedReview.period',
  'rs.skippedReview.policy-title',
  'rs.skippedReview.policy',
  'rs.skippedReview.old-project-number',
  'rs.skippedReview.project-order-number',
  'rs.skippedReview.remark',
]);

//// 予算執行タブ
export const RsSkippedReviewDetailedBreakdownScenePinpointFieldEnum = z.enum([
  'rs.skippedReview.budget-and-execution-title',
  'rs.skippedReview.budget-and-execution',
  'rs.skippedReview.increase-decrease-main-reason',
  'rs.skippedReview.other-special-notes',
]);

export const RsSkippedReviewRelatedMaterialScenePinpointFieldEnum = z.enum([
  'rs.skippedReview.related-material-image',
  'rs.skippedReview.related-material-remark',
]);

export const RsSkippedReviewPinpointFieldEnum = z.enum([
  ...RsSkippedReviewBasicInformationScenePinpointFieldEnum.options,
  ...RsSkippedReviewDetailedBreakdownScenePinpointFieldEnum.options,
  ...RsSkippedReviewRelatedMaterialScenePinpointFieldEnum.options,
]);

/// ////////////////////////////////////////////
/// pinpointの値の組み合わせを明示的に定義する
/// ////////////////////////////////////////////

export const RsSkippedReviewPinpointMultipleFieldEnum = z.enum([
  RsSkippedReviewBasicInformationScenePinpointFieldEnum.Enum[
    'rs.skippedReview.policy'
  ],
  RsSkippedReviewDetailedBreakdownScenePinpointFieldEnum.Enum[
    'rs.skippedReview.budget-and-execution'
  ],
]);

type RsSkippedReviewPinpointMultipleFieldEnumFieldEnumType =
  typeof RsSkippedReviewPinpointMultipleFieldEnum.Enum;

export type RsSkippedReviewMultiplePinpointMappingType =
  | {
      path: z.infer<typeof policyProjectPathObj>;
      field: RsSkippedReviewPinpointMultipleFieldEnumFieldEnumType['rs.skippedReview.policy'];
    }
  | {
      path: z.infer<typeof budgetAndExecutionPathObj>;
      field: RsSkippedReviewPinpointMultipleFieldEnumFieldEnumType['rs.skippedReview.budget-and-execution'];
    };

type ProjectPinpointMappingType = {
  path: z.infer<typeof projectPathObj>;
  field: Exclude<
    | z.infer<typeof RsSkippedReviewBasicInformationScenePinpointFieldEnum>
    | z.infer<typeof RsSkippedReviewDetailedBreakdownScenePinpointFieldEnum>
    | z.infer<typeof RsSkippedReviewRelatedMaterialScenePinpointFieldEnum>,
    z.infer<typeof RsSkippedReviewPinpointMultipleFieldEnum>
  >;
};

export type RsSkippedReviewPinpointMappingType =
  | ProjectPinpointMappingType
  | RsSkippedReviewMultiplePinpointMappingType;
